/** Web/Electron SPA build stub for @capacitor/core (Capacitor deps live under src-capacitor in native builds). */

export const Capacitor = {
  convertFileSrc: (filePath) => filePath,
  getPlatform: () => 'web',
  isNativePlatform: () => false,
  isPluginAvailable: () => false,
  registerPlugin: () => ({})
}
